module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top heightAuto",
    attrs: {
      "dialog": "modal-lg",
      "footer": true
    },
    on: {
      "closemodal": function($event) {
        _vm.getReservation.billing.payments.length = 0
      },
      "close": _vm.clickCancel
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Booking Question")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "m-4"
  }, [_c('h3', [_vm._v(_vm._s(_vm.reservation.event.bookingQuestion))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.bookingAnswer),
      expression: "reservation.bookingAnswer"
    }],
    ref: "bookingAnswer",
    staticClass: "w-100 mt-3",
    attrs: {
      "type": "text",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.reservation.bookingAnswer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "bookingAnswer", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel widest",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok widest",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.clickContinue
    }
  }, [_vm._v("Continue")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7dbb87f4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dbb87f4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/bookingQuestion.vue
// module id = 2165
// module chunks = 0